import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const bgClass = scrolled || !isHome
    ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
    : 'bg-transparent';

  const textClass = scrolled || !isHome
    ? 'text-foreground-800'
    : 'text-white';

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/jichu-jiqiao', label: '基础技巧' },
    { to: '/category/jinjie-bianshi', label: '进阶变式' },
    { to: '/category/jiaodu-tiaozheng', label: '角度调整' },
    { to: '/category/jiankang-anquan', label: '健康安全' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`flex items-center gap-2 ${textClass}`}>
            <span className="text-lg font-semibold font-heading whitespace-nowrap">体位指南</span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-primary-500 cursor-pointer ${
                  location.pathname === link.to ? 'text-primary-500' : textClass
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${textClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-3">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}